
import { Options, Vue} from 'vue-class-component';
import HelloWorld from '@/components/HelloWorld.vue';
import {useStore} from "vuex"; // @ is an alias to /src

import  {getLocalStorage,setLocalStorage,loginOutDataClear} from "@/public/storage";
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';


// 首先，在 vue 3.0 中，生命周期是从 vue 中导出的，我们需要用到哪些，就导出哪些。
import { defineComponent,ref, onBeforeMount,computed,
  onMounted,
  onBeforeUpdate,
  onUpdated,
  onBeforeUnmount,
  onUnmounted,
  getCurrentInstance,
  reactive
} from "vue";
import basicApi from '../public/http/index';

export default {
  //始化数据,介于beforeCreate与created之间，相当于beforeCreate、created的合并
  setup() {
    const count = ref(0);
    const storeName = ref('');
    const imageCode = ref('');
    const title = ref('这是data的数据');
    const drawerModel = ref(false);
    const loginOutModel = ref(false);

    const stateDom = ref(null);
    const ctx:any = null;
    const router = useRouter();
    // ctx = getCurrentInstance();

    // var obj: any = Object.create(null);
    var obj: any  = getCurrentInstance();
    console.log('home_ctx',obj)
    setLocalStorage('key', 'aaaa');
    console.log('setup', useStore);
    const hello: string = "Hello World!";
    console.log(hello);

    let json =  localStorage.getItem('collegeDetail')
    if(json){
      let  collegeDetail = JSON.parse(json)
      console.log('get_screen_background',collegeDetail,)

      basicApi.get_screen_background(collegeDetail.collegeid).then((res:any) => {
        if(res.data.background){
          console.log('get_screen_background',res.data.background)
          localStorage.setItem('background',JSON.stringify(res.data.background))
        }
      }).catch((err:any) => {
        console.log('getData', err)
      });
    }

    computed(() => {
      storeName.value = useStore().state.name
      // let collogeId:string = localStorage.getItem('collegeId')



    })
    storeName.value = useStore().state.name;

    // 其他的生命周期都写在这里
    onBeforeMount(() => {
      count.value++
      console.log('onBeforeMount', count.value)
    })
    onMounted(() => {
      count.value++



    })
    // 注意，onBeforeUpdate 和 onUpdated 里面不要修改值，会死循环的哦！
    onBeforeUpdate(() => {
      console.log('onBeforeUpdate', count.value)
    })
    onUpdated(() => {
      console.log('onUpdated', count.value)
    });
    onBeforeUnmount(() => {
      count.value++;
      console.log('onBeforeUnmount', count.value)
    })
    onUnmounted(() => {
      count.value++;
      console.log('onUnmounted', count.value)
    })
    // 定义一个函数，修改 count 的值。
    const countAdd = () => {
      count.value++;
    };

    function deleteCount() {
      count.value = 0;
    }

    function getTitle() {
      return '张大海 ----> 这是带有返回值的函数'
    }

    function getHTTPdate() {
      count.value = 0;
    }

    const drawerClick = () => {
      drawerModel.value = false;
    }

    function  userLoginOut() {
        ElMessage('退出成功');
        let collegeId = getLocalStorage('collegeId');
        loginOutDataClear();
        router.push({path:"/login",query:{collegeId:collegeId}});
    }


    return {
      count,
      countAdd,
      deleteCount,
      storeName,
      imageCode,
      stateDom,
      title,
      getTitle,
      drawerModel,
      drawerClick,
      loginOutModel,
      userLoginOut
    }
  },
  computed: {},

  methods: {
    gotoAbout() {
      console.log('gotoAbout');
      this.$router.push('/about')
    },
    gotohome() {
      this.$router.push('/home/newPage')
    },
    gotopage(page: any) {
      // this.$router.push('/home/' + page)

      let routeUrl = this.$router.resolve({
        path:'/home/' + page
      });
      window.open(routeUrl.href, '_blank');
    },
    getStore() {
      console.log('getStore', this.$store.state.name);
      this.storeName = this.$store.state.name;
    },
    updateStoreClick() {
      this.$store.commit('setTitle', new Date())
      console.log('getStore', this.$store.state.name)

    },
    clearCache(){
      basicApi.clear_cache().then((res:any) => {
        console.log(4444,res)
        if(res.status){
          ElMessage('清除成功');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
    }
  },
}

// @Options({
//   components: {
//     HelloWorld,
//   },
// })
// export default class Home extends Vue {
//   name:string='asdasdasd';
//   msg: string = '这是公共的头部';
//   //需要非常注意的是在vue3.0的setup 函数中是无法访问到this的
//   setup() {
//     const store = useStore();
//     console.log('setup',store)

//   }
//     gotoAbout(){
//     console.log('gotoAbout')
//     this.$router.push('/about')
//   }
//   gotohome(){
//     this.$router.push('/home/newPage')
//   }
//   gotopage(page:any){
//     this.$router.push('/home/'+ page)

//   }
//   getStore(){
//      console.log('getStore',this.name)
//   }
// }
